<template>
  <div class="table-list" v-loading="loading">
    <div class="table-content">
      <!-- 表格数据 -->
      <!-- <el-checkbox-group v-model="selectListVal"> -->
      <el-table
        :data="listData"
        header-cell-class-name="dark"
        :height="tableHeight"
        stripe
        border
        @selection-change="handleSelectionChangePeople"
      >
        <table-column type="selection" width="55" :selectable="selectable" />
        <table-column prop="createTime" label="进件时间"></table-column>
        <table-column prop="merId" label="档案号"></table-column>
        <table-column prop="merName" label="商户名称"></table-column>
        <table-column prop="corpName" label="法人姓名"></table-column>
        <table-column prop="corpPhone" label="联系电话">
          <!-- <span slot-scope="scope">{{
            scope.row.corpPhone | hideCorpPhone
          }}</span> -->
        </table-column>
        <table-column prop="area" label="城市"></table-column>
        <table-column prop="orgName" label="收单机构"></table-column>
        <table-column prop="serviceName" label="城市服务商"></table-column>
        <table-column prop="bankName" label="渠道"></table-column>
        <table-column prop="quota" label="批复额度"></table-column>
        <table-column prop="activeType" label="激活状态">
          <span slot-scope="{ row }">{{
            row.activeType | filterAcitveType
          }}</span>
        </table-column>

        <el-table-column width="80">
          <div slot="header" class="fixed-right-column">操作</div>

          <!-- <template #row>{{ row }}</template> -->
          <router-link
            slot-scope="{ row }"
            :to="`/home/merActivate/details/${row.merId}/${row.bankExit}`"
            >查看</router-link
          >
        </el-table-column>
      </el-table>
      <!-- </el-checkbox-group> -->
    </div>
  </div>
</template>

<script>
import mixin from '@/mixins/dataListHeight.js'
export default {
  mixins: [mixin],
  props: {
    listData: {
      type: Array,
      default() {
        return []
      }
    },
    selectList: {
      type: Array,
      default() {
        return []
      },
      comment: '多选框数据列表'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleSelectionChangePeople(rows) {
      this.$emit('checkboxData', rows)
      this.$store.commit('T7/merActivate/setCheckoutListData', rows)
    },
    selectable(row, index) {
      if (row.bankExit == 2) {
        return true
      } else {
        return false
      }
    }
  },

  computed: {
    selectListVal: {
      get() {
        return this.selectList
      },
      set(val) {
        this.$emit('update:selectList', val)
      }
    }
  },

  filters: {
    filterSettle(num) {
      return {
        null: '-',
        '-1': '等待清算',
        '0': '发起清算 ',
        '1': '清算成功',
        '2': '清算失败'
      }[num]
    },
    filtercheck(num) {
      return {
        null: '-',
        '0': '未对账 ',
        '1': '对账成功(正常)',
        '2': '强制平账',
        '3': '短款(平台缺失) ',
        '4': '长款(银行缺失)',
        '5': '交易状态不符',
        '6': '清算状态不符 ',
        '7': '交易金额不符',
        '8': '清算金额不符'
      }[num]
    },
    filterAcitveType(num) {
      return {
        null: '-',
        '': '-',
        8: '待激活',
        19: '激活中',
        20: '激活失败待重新激活'
        // 8: '续约待激活',
        // 19: '续约激活中',
        // 20: '续约激活失败待重新激活'
      }[num]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/Common/tableList.scss';
</style>
